import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../auth/AuthProvider';
import { consumePostLoginRedirect } from '../auth/redirect';

export const CallbackPage: React.FC = () => {
  const navigate = useNavigate();
  const { initialized, authenticated } = useAuth();

  useEffect(() => {
    if (!initialized || !authenticated) return;
    const target = consumePostLoginRedirect();
    navigate(target, { replace: true });
  }, [initialized, authenticated, navigate]);

  return <div />;
};


